export default "__VITE_ASSET__82ca6558__"